module.exports = __webpack_public_path__ + "img/last-quarter-moon-face.bd83185f.png";